<template>
  <div class="lds-css ng-scope">
    <div class="lds-spin"  style="width:100%;height:100%">
      <div style="background-color:rgb(55, 71, 79)"><div style="background-color:rgb(55, 71, 79)"></div></div><div style="background-color:rgb(55, 71, 79)"><div style="background-color:rgb(55, 71, 79)"></div></div><div style="background-color:rgb(55, 71, 79)"><div style="background-color:rgb(55, 71, 79)"></div></div><div style="background-color:rgb(55, 71, 79)"><div style="background-color:rgb(55, 71, 79)"></div></div><div style="background-color:rgb(55, 71, 79)"><div style="background-color:rgb(55, 71, 79)"></div></div><div style="background-color:rgb(55, 71, 79)"><div style="background-color:rgb(55, 71, 79)"></div></div><div style="background-color:rgb(55, 71, 79)"><div style="background-color:rgb(55, 71, 79)"></div></div><div style="background-color:rgb(55, 71, 79)"><div style="background-color:rgb(55, 71, 79)"></div></div><div style="background-color:rgb(55, 71, 79)"><div style="background-color:rgb(55, 71, 79)"></div></div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    name: 'spinner',
    computed: {
      ...mapState({
        cor: state => {
          const {corSelecionado} = state.cor
          return {
            'background-color': corSelecionado
          }
        }
      })
    }
  }
</script>
<style scoped>
  .lds-spin{
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/SpinnerVue.vue